import { AnyAction } from "redux";
import * as actionTypes from "./actionTypes";

export const getMatches = (): AnyAction => ({
  type: actionTypes.MATHCES_GET_MATCHES,
});
